// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.card_card-container-overlay_HOWEv {
    position: fixed;
    pointer-events: none;
    z-index: 480;
}

.card_card-container_Cs0OY {
    position:absolute;
    pointer-events: auto;
    z-index: 480;
    margin: 0.5rem 2rem;
    min-width: 468px;
}

.card_left-card_ULEGo, .card_right-card_OO7xe {
    height: 90%;
    position: absolute;
    top: 5%;
    background: var(--ui-white);
    border: 1px solid var(--ui-tertiary);
    width: .75rem;
    z-index: 10;
    opacity: 0.9;
    overflow: hidden;
}

.card_left-card_ULEGo {
    left: -.75rem;
    border-right: 0;
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
}

.card_right-card_OO7xe {
    right: -.75rem;
    border-left: 0;
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
}

.card_left-card_ULEGo::after, .card_right-card_OO7xe::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 2.5rem;
    width: 100%;
    background: var(--extensions-primary);
}

.card_left-button_cGYrp, .card_right-button_iYn5S {
    position: absolute;
    top: 50%;
    margin-top: -15px;
    z-index: 20;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    background: var(--extensions-primary);
    box-shadow: 0 0 0 4px var(--extensions-transparent);
    height: 44px;
    width: 44px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.25s ease;
}

.card_left-button_cGYrp:hover, .card_right-button_iYn5S:hover {
    box-shadow: 0 0 0 6px var(--extensions-transparent);
    transform: scale(1.125);
}

.card_left-button_cGYrp img, .card_right-button_iYn5S img{
    width: 1.75rem;
}

.card_left-button_cGYrp {
    left: -27px;
}

.card_right-button_iYn5S {
    right: -27px;
}

.card_card_wHoAD {
    border: 1px solid var(--ui-tertiary);
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    cursor: move;
    z-index: 20;
    overflow: hidden;
    box-shadow: 0px 5px 25px 5px var(--shadow);
    align-items: center;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.card_header-buttons_Ms0WR {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: var(--extensions-primary);
    border-bottom: 1px solid var(--extensions-tertiary);
    font-size: 0.625rem;
    font-weight: bold;
}

.card_header-buttons-hidden_RyHRA {
    border-bottom: 0px;
}

.card_header-buttons-right_VPQKd {
    display: flex;
    flex-direction: row;
}

.card_header-buttons_Ms0WR img {
    margin-bottom: 2px;
}

.card_shrink-expand-button_r5Hjj {
    cursor: pointer;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
}

.card_shrink-expand-button_r5Hjj:hover, .card_all-button_drR8x:hover {
    background-color: var(--ui-black-transparent);
}

.card_remove-button_B_2wK, .card_all-button_drR8x {
    cursor: pointer;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
}

.card_remove-button_B_2wK:hover, .card_all-button_drR8x:hover {
    background-color: var(--ui-black-transparent);
}

.card_step-title_mb25I {
    font-size: 0.9rem;
    margin: 0.9rem;
    text-align: center;
    font-weight: bold;
    color: var(--text-primary);
}

.card_step-body_k2wJJ {
    width: 100%;
    background: var(--ui-white);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    text-align: center;

    /* Min height prevents layout changing when images change */
    min-height: 256px;
}

.card_step-video_ENQHM {
    height: 256px;
}

.card_step-image_AcHFk {
    max-width: 450px;
    max-height: 200px;
    object-fit: contain;
    background: #F9F9F9;
    border: 1px solid #ddd;
    border-radius: 0.5rem;
    overflow: hidden;
    margin: 0 0.5rem 0.5rem;
}

.card_decks_YZrRK {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 0 1rem 0.5rem;
}

.card_deck_rUBeV {
    display: flex;
    flex-direction: column;
    margin: 0 8px 8px;
    cursor: pointer;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    overflow: hidden;
}

.card_deck-image_P53kP {
    width: 200px;
    height: 100px;
    object-fit: cover;
}

.card_deck-name_aivP5 {
    color: var(--looks-secondary);
    font-weight: bold;
    font-size: 0.85rem;
    margin: .625rem 0px;
    text-align: center;
    font-weight: bold;
    text-align: center;
    max-width: 200px;
}

.card_help-icon_LELqy {
    height: 1.25rem;
}

.card_close-icon_ViJ3D {
    height: 1.25rem;
    margin: .125rem 0; /* To offset the .25rem difference in icon size */
}

[dir="ltr"] .card_help-icon_LELqy {
    margin-right: 0.25rem;
}

[dir="rtl"] .card_help-icon_LELqy {
    margin-left: 0.25rem;
}

[dir="ltr"] .card_close-icon_ViJ3D {
    margin-left: 0.25rem;
}

[dir="rtl"] .card_close-icon_ViJ3D {
    margin-right: 0.25rem;
}

.card_see-all_I8clp {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding: 0.5rem;
}

.card_see-all-button_AWMlV {
    cursor: pointer;
    padding: 0.5rem 1rem;
    background-color: var(--looks-secondary);
    color: white;
    font-weight: bold;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    color: var(--ui-white);
    font-size: .75rem;
    font-weight: bold;
    line-height: 1rem;
    text-align: center;
}

[dir="ltr"] .card_see-all-button_AWMlV img {
    margin-left: 0.5rem;
}

[dir="rtl"] .card_see-all-button_AWMlV img {
    margin-right: 0.5rem;
}

.card_steps-list_XaR70 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.card_active-step-pip_pv1GI, .card_inactiveStepPip_sFcGX {
    width: 0.5rem;
    height: 0.5rem;
    margin: 0 0.25rem;
    border-radius: 100%;
    background: var(--ui-white-transparent);
}

.card_active-step-pip_pv1GI {
    background: var(--ui-white);
    box-shadow: 0px 0px 0px 2px var(--shadow);
}

.card_hidden_SU1jH {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/card.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,2BAA2B;IAC3B,oCAAoC;IACpC,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IACd,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,qCAAqC;IACrC,mDAAmD;IACnD,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mDAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;IACrC,mDAAmD;IACnD,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;;IAElB,2DAA2D;IAC3D,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,6CAA6C;IAC7C,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB,EAAE,iDAAiD;AACxE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,wCAAwC;IACxC,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.card-container-overlay {\n    position: fixed;\n    pointer-events: none;\n    z-index: 480;\n}\n\n.card-container {\n    position:absolute;\n    pointer-events: auto;\n    z-index: 480;\n    margin: 0.5rem 2rem;\n    min-width: 468px;\n}\n\n.left-card, .right-card {\n    height: 90%;\n    position: absolute;\n    top: 5%;\n    background: var(--ui-white);\n    border: 1px solid var(--ui-tertiary);\n    width: .75rem;\n    z-index: 10;\n    opacity: 0.9;\n    overflow: hidden;\n}\n\n.left-card {\n    left: -.75rem;\n    border-right: 0;\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n}\n\n.right-card {\n    right: -.75rem;\n    border-left: 0;\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n}\n\n.left-card::after, .right-card::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 2.5rem;\n    width: 100%;\n    background: var(--extensions-primary);\n}\n\n.left-button, .right-button {\n    position: absolute;\n    top: 50%;\n    margin-top: -15px;\n    z-index: 20;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    background: var(--extensions-primary);\n    box-shadow: 0 0 0 4px var(--extensions-transparent);\n    height: 44px;\n    width: 44px;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.25s ease;\n}\n\n.left-button:hover, .right-button:hover {\n    box-shadow: 0 0 0 6px var(--extensions-transparent);\n    transform: scale(1.125);\n}\n\n.left-button img, .right-button img{\n    width: 1.75rem;\n}\n\n.left-button {\n    left: -27px;\n}\n\n.right-button {\n    right: -27px;\n}\n\n.card {\n    border: 1px solid var(--ui-tertiary);\n    border-radius: 0.75rem;\n    display: flex;\n    flex-direction: column;\n    cursor: move;\n    z-index: 20;\n    overflow: hidden;\n    box-shadow: 0px 5px 25px 5px var(--shadow);\n    align-items: center;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.header-buttons {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    background: var(--extensions-primary);\n    border-bottom: 1px solid var(--extensions-tertiary);\n    font-size: 0.625rem;\n    font-weight: bold;\n}\n\n.header-buttons-hidden {\n    border-bottom: 0px;\n}\n\n.header-buttons-right {\n    display: flex;\n    flex-direction: row;\n}\n\n.header-buttons img {\n    margin-bottom: 2px;\n}\n\n.shrink-expand-button {\n    cursor: pointer;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0.75rem;\n}\n\n.shrink-expand-button:hover, .all-button:hover {\n    background-color: var(--ui-black-transparent);\n}\n\n.remove-button, .all-button {\n    cursor: pointer;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0.75rem;\n}\n\n.remove-button:hover, .all-button:hover {\n    background-color: var(--ui-black-transparent);\n}\n\n.step-title {\n    font-size: 0.9rem;\n    margin: 0.9rem;\n    text-align: center;\n    font-weight: bold;\n    color: var(--text-primary);\n}\n\n.step-body {\n    width: 100%;\n    background: var(--ui-white);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    text-align: center;\n\n    /* Min height prevents layout changing when images change */\n    min-height: 256px;\n}\n\n.step-video {\n    height: 256px;\n}\n\n.step-image {\n    max-width: 450px;\n    max-height: 200px;\n    object-fit: contain;\n    background: #F9F9F9;\n    border: 1px solid #ddd;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    margin: 0 0.5rem 0.5rem;\n}\n\n.decks {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    padding: 0 1rem 0.5rem;\n}\n\n.deck {\n    display: flex;\n    flex-direction: column;\n    margin: 0 8px 8px;\n    cursor: pointer;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    overflow: hidden;\n}\n\n.deck-image {\n    width: 200px;\n    height: 100px;\n    object-fit: cover;\n}\n\n.deck-name {\n    color: var(--looks-secondary);\n    font-weight: bold;\n    font-size: 0.85rem;\n    margin: .625rem 0px;\n    text-align: center;\n    font-weight: bold;\n    text-align: center;\n    max-width: 200px;\n}\n\n.help-icon {\n    height: 1.25rem;\n}\n\n.close-icon {\n    height: 1.25rem;\n    margin: .125rem 0; /* To offset the .25rem difference in icon size */\n}\n\n[dir=\"ltr\"] .help-icon {\n    margin-right: 0.25rem;\n}\n\n[dir=\"rtl\"] .help-icon {\n    margin-left: 0.25rem;\n}\n\n[dir=\"ltr\"] .close-icon {\n    margin-left: 0.25rem;\n}\n\n[dir=\"rtl\"] .close-icon {\n    margin-right: 0.25rem;\n}\n\n.see-all {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n    padding: 0.5rem;\n}\n\n.see-all-button {\n    cursor: pointer;\n    padding: 0.5rem 1rem;\n    background-color: var(--looks-secondary);\n    color: white;\n    font-weight: bold;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    color: var(--ui-white);\n    font-size: .75rem;\n    font-weight: bold;\n    line-height: 1rem;\n    text-align: center;\n}\n\n[dir=\"ltr\"] .see-all-button img {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .see-all-button img {\n    margin-right: 0.5rem;\n}\n\n.steps-list {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.active-step-pip, .inactiveStepPip {\n    width: 0.5rem;\n    height: 0.5rem;\n    margin: 0 0.25rem;\n    border-radius: 100%;\n    background: var(--ui-white-transparent);\n}\n\n.active-step-pip {\n    background: var(--ui-white);\n    box-shadow: 0px 0px 0px 2px var(--shadow);\n}\n\n.hidden {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `card_card-container-overlay_HOWEv`;
export { _1 as "card-container-overlay" };
export var cardContainerOverlay = `card_card-container-overlay_HOWEv`;
var _2 = `card_card-container_Cs0OY`;
export { _2 as "card-container" };
export var cardContainer = `card_card-container_Cs0OY`;
var _3 = `card_left-card_ULEGo`;
export { _3 as "left-card" };
export var leftCard = `card_left-card_ULEGo`;
var _4 = `card_right-card_OO7xe`;
export { _4 as "right-card" };
export var rightCard = `card_right-card_OO7xe`;
var _5 = `card_left-button_cGYrp`;
export { _5 as "left-button" };
export var leftButton = `card_left-button_cGYrp`;
var _6 = `card_right-button_iYn5S`;
export { _6 as "right-button" };
export var rightButton = `card_right-button_iYn5S`;
export var card = `card_card_wHoAD`;
var _7 = `card_header-buttons_Ms0WR`;
export { _7 as "header-buttons" };
export var headerButtons = `card_header-buttons_Ms0WR`;
var _8 = `card_header-buttons-hidden_RyHRA`;
export { _8 as "header-buttons-hidden" };
export var headerButtonsHidden = `card_header-buttons-hidden_RyHRA`;
var _9 = `card_header-buttons-right_VPQKd`;
export { _9 as "header-buttons-right" };
export var headerButtonsRight = `card_header-buttons-right_VPQKd`;
var _a = `card_shrink-expand-button_r5Hjj`;
export { _a as "shrink-expand-button" };
export var shrinkExpandButton = `card_shrink-expand-button_r5Hjj`;
var _b = `card_all-button_drR8x`;
export { _b as "all-button" };
export var allButton = `card_all-button_drR8x`;
var _c = `card_remove-button_B_2wK`;
export { _c as "remove-button" };
export var removeButton = `card_remove-button_B_2wK`;
var _d = `card_step-title_mb25I`;
export { _d as "step-title" };
export var stepTitle = `card_step-title_mb25I`;
var _e = `card_step-body_k2wJJ`;
export { _e as "step-body" };
export var stepBody = `card_step-body_k2wJJ`;
var _f = `card_step-video_ENQHM`;
export { _f as "step-video" };
export var stepVideo = `card_step-video_ENQHM`;
var _10 = `card_step-image_AcHFk`;
export { _10 as "step-image" };
export var stepImage = `card_step-image_AcHFk`;
export var decks = `card_decks_YZrRK`;
export var deck = `card_deck_rUBeV`;
var _11 = `card_deck-image_P53kP`;
export { _11 as "deck-image" };
export var deckImage = `card_deck-image_P53kP`;
var _12 = `card_deck-name_aivP5`;
export { _12 as "deck-name" };
export var deckName = `card_deck-name_aivP5`;
var _13 = `card_help-icon_LELqy`;
export { _13 as "help-icon" };
export var helpIcon = `card_help-icon_LELqy`;
var _14 = `card_close-icon_ViJ3D`;
export { _14 as "close-icon" };
export var closeIcon = `card_close-icon_ViJ3D`;
var _15 = `card_see-all_I8clp`;
export { _15 as "see-all" };
export var seeAll = `card_see-all_I8clp`;
var _16 = `card_see-all-button_AWMlV`;
export { _16 as "see-all-button" };
export var seeAllButton = `card_see-all-button_AWMlV`;
var _17 = `card_steps-list_XaR70`;
export { _17 as "steps-list" };
export var stepsList = `card_steps-list_XaR70`;
var _18 = `card_active-step-pip_pv1GI`;
export { _18 as "active-step-pip" };
export var activeStepPip = `card_active-step-pip_pv1GI`;
export var inactiveStepPip = `card_inactiveStepPip_sFcGX`;
export var hidden = `card_hidden_SU1jH`;
export default ___CSS_LOADER_EXPORT___;
